// extracted by mini-css-extract-plugin
export default {"description":"BasicTab__description___p_aUf","descriptionTabName":"BasicTab__descriptionTabName___Ur5iM"};